import "./banner/Banner.css";
import React, { useState } from "react";
import Banner from "./banner/Banner";
import Demo_Product from "./demo_product/Demo_Product";
import All_Time_Fav from "./all_time_fav/All_Time_Fav";
import Product_vdo_preview from "./product_vdo_preview/Product_vdo_preview";
import Farming_on_purpose from "./farming_on_purpose/Farming_on_purpose";
import Farm_vdo from "./farm_vdo/Farm_vdo";
import Harvested_By_you from "./harvested_by_you/Harvested_By_you";
import Our_philosophy from "./our_philosophy/Our_philosophy";
import Explore_our_fresh_produce from "./explore_our_fresh_produce/Explore_our_fresh_produce";
import Philosophy_grounded_in_nature from "./philosophy_grounded_in_nature/Philosophy_grounded_in_nature";
import Testimonials from "./testimonials/Testimonials";
import Food_and_wellness_journal from "./food_and_wellness_journal/Food_and_wellness_journal";
import Stay_Connected from "./stay_Connected/Stay_Connected";
import Category_section from "./category-section/Category_section";
import { useDispatch, useSelector } from "react-redux";
import { AllShape, getAllCategories } from "../../features/master/masterSlice";
import { useEffect } from "react";
import "./Home.css";
import {
  getAllProducts,
  getAllTimeFavsProducts,
} from "../../features/products/productsSlice";
import {
  getHomeBanner,
  getHomeShopAndWatch,
} from "../../features/home/homeSlice";
import Demo_ProductCategory from "./demo_product/Demo_ProductCategory";
import { getAboutUs } from "../../features/aboutus/aboutusSlice";
import AOS from "aos";
import "aos/dist/aos.css";
import ImageSwipper from "./image_swipper/Image_Swipper";
import Shop_By_Shape from "./shop_by_shape/Shop_By_Shape";
import Reels from "./reels/Reels";
import { useNavigate } from "react-router-dom";
import Popular_Product from "./popular_product/Popular_Product";
import Explore_By_Category from "./explore_by_category/Explore_By_Category";
import Offers_Slider from "./offers_slider/Offers_Slider";
import Common_Product_Swiper from "../common-components/common_product_swiper/Common_Product_Swiper";
import New_In_Store from "./new_in_store/New_In_Store";
import Banner_Btn_Component from "./banner_btn_component/Banner_Btn_Component";
import Offer_Products from "./offer_products/Offer_Products";

function Home() {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  AOS.init({ disable: "mobile" });

  const category = useSelector((state) => state.master.categories);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAllCategories());
  }, [dispatch]);

  const banner = useSelector((state) => state.home.banners);

  useEffect(() => {
    dispatch(getHomeBanner());
  }, [dispatch]);

  const about_us = useSelector((state) => state.aboutus.about_us);

  useEffect(() => {
    dispatch(getAboutUs());
  }, [dispatch]);

  const shapes = useSelector((state) => state.master.all_shape);

  useEffect(() => {
    dispatch(AllShape());
  }, [dispatch]);

  const watch_and_shop = useSelector(
    (state) => state.home.all_home_shop_and_watch,
  );

  useEffect(() => {
    dispatch(getHomeShopAndWatch());
  }, [dispatch]);

  const navigate = useNavigate();

  const data = [
    "/assets/images/offer_slider/img1.png",
    "/assets/images/offer_slider/img2.png",
    "/assets/images/offer_slider/img1.png",
  ];

  const data1 = [
    {
      img: "/assets/images/products/img1.png",
      label: "Vegetables",
    },
    {
      img: "/assets/images/products/img2.png",
      label: "Fresh Fruits",
    },
    {
      img: "/assets/images/products/img1.png",
      label: "Vegetables",
    },
    {
      img: "/assets/images/products/img2.png",
      label: "Fresh Fruits",
    },
    {
      img: "/assets/images/products/img1.png",
      label: "Vegetables",
    },
    {
      img: "/assets/images/products/img2.png",
      label: "Fresh Fruits",
    },
    {
      img: "/assets/images/products/img1.png",
      label: "Vegetables",
    },
    {
      img: "/assets/images/products/img2.png",
      label: "Fresh Fruits",
    },
    {
      img: "/assets/images/products/img1.png",
      label: "Vegetables",
    },
    {
      img: "/assets/images/products/img2.png",
      label: "Fresh Fruits",
    },
  ];

  const data2 = [
    {
      img: "/assets/images/products/img8.png",
      label: "Soap",
    },
    {
      img: "/assets/images/products/img7.png",
      label: "Shampooo & Moisturisers",
    },
    {
      img: "/assets/images/products/img8.png",
      label: "Soap",
    },
    {
      img: "/assets/images/products/img7.png",
      label: "Shampooo & Moisturisers",
    },
    {
      img: "/assets/images/products/img8.png",
      label: "Soap",
    },
    {
      img: "/assets/images/products/img7.png",
      label: "Shampooo & Moisturisers",
    },
    {
      img: "/assets/images/products/img8.png",
      label: "Soap",
    },
    {
      img: "/assets/images/products/img7.png",
      label: "Shampooo & Moisturisers",
    },
  ];

  const newInStore = useSelector((state) => state.product.allProductsFavs);

  useEffect(() => {
    dispatch(getAllTimeFavsProducts({}));
  }, [dispatch]);

  console.log("newInStore", newInStore);

  return (
    <>
      <section className="Home">
        <div className="container">
          <div className="desktop_view">
            <div className="row me-0 ms-0 ">
              <div className="col-xxl-2 col-xl-3 col-lg-3">
                <div className="row justify-content-between custom_row me-0 ms-0">
                  <div className="col-lg-12 col-sm-6">
                    <div className="cat_div">
                      <button
                        className="cat_btn"
                        type="button"
                        onClick={() => {
                          navigate("/shop");
                        }}
                      >
                        <div className="left_side">
                          <div className="icon_holder">
                            <img
                              src="/assets/images/popular_products/bars.png"
                              className="bar_img"
                            />
                            <img
                              src="/assets/images/popular_products/bar_sort.png"
                              className="sort_bar_img"
                            />
                          </div>

                          <p className="btn_text">Categories</p>
                        </div>
                      </button>
                    </div>

                    <div className="popular_prod">
                      <Popular_Product />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xxl-10 col-xl-9 col-lg-9">
                <div className="body_container">
                  <Banner banner={banner} />
                  <Explore_By_Category />

                  {/* {coupons?.data?.length > 0 && ( */}
                  <Offers_Slider coupons={data} />
                  {/* )} */}

                  <div className="grocery_div">
                    <Common_Product_Swiper
                      data={data1}
                      theme_colour={"green"}
                      headingText="Grocery & Kitchen"
                    />
                  </div>

                  <div className="snacks_div">
                    <Common_Product_Swiper
                      data={data2}
                      theme_colour={"dark_green"}
                      headingText="Hygine & Personal Care"
                    />
                  </div>

                  <New_In_Store data={newInStore} />

                  <Banner_Btn_Component />

                  <Offer_Products offerProducts={newInStore} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;
